<template>
  <span>
    <CheckoutPaymentPixQRCode v-if="showQrCode" :installmentId="installmentId" :pixStringCode="pixStringCode" :pixQRCode="pixQRCode" />
    <v-form v-else ref="form" lazy-validation>
      <v-text-field
        v-model="name"
        :rules="[rules.name]"s
        :label="nameLabel"
        outlined
      />
      <v-text-field
        v-model="document"
        v-mask="documentMask"
        :rules="documentRules"
        :label="documentLabel"
        outlined
      />
      <div class="d-flex justify-end">
        <v-btn @click="submit" :loading="loading" color="primary" elevation="0" large>
          {{ actionLabel }}
        </v-btn>
      </div>
    </v-form>
  </span>
</template>

<script>
// utils
import { cpfCnpj } from '@/util/masks'
import { name, required } from '@/util/errorHandling'
import { validateCPF, validateCNPJ } from '@/util/validate'

// api
import { chargeSubscription } from '../checkoutService'

// components
import CheckoutPaymentPixQRCode from '../fragments/CheckoutPaymentPixQRCode.vue'

export default {
  name: 'CheckoutPaymentPix',

  props: {
    planAmount: {
      type: Number,
      required: true,
    },
  },

  components: {
    CheckoutPaymentPixQRCode
  },

  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return

      this.loading = true

      try {
        const document = this.document.replace(/[^0-9]+/g, '')
        const amount = this.planAmount.toFixed(2)

        const paymentData = {
          payer_name: this.name,
          payer_document: document,
          installment_amount: 1,
          method: 'ASAAS_PIX',
          value: amount,
        }

        const response = await chargeSubscription(paymentData)
        const data = response.data

        this.pixQRCode = data.installments[0].pix_qrcode_image
        this.pixStringCode = data.installments[0].pix_string_code
        this.installmentId = data.id

        this.showQrCode = true
      } catch (error) {
        console.error('Payment error:', error)
      } finally {
        this.loading = false
      }
    },
  },

  computed: {
    documentMask() {
      return this.document.length <= 14
        ? this.mask.cpfCnpj.cpf
        : this.mask.cpfCnpj.cnpj
    },

    documentRules() {
      return this.document.length <= 14
        ? [this.rules.cpf]
        : [this.rules.cnpj]
    },
  },

  data() {
    return {
      name: '',
      document: '',

      nameLabel: this.$t('forms.completeName'),
      documentLabel: this.$t('forms.cpfCnpj'),
      cancelLabel: this.$t('forms.cancel'),
      actionLabel: this.$t('forms.confirm'),
      invalidCPFLabel: this.$t('onboarding.register.errors.cpf'),
      invalidCNPJLabel: this.$t('onboarding.register.errors.cnpj'),

      rules: {
        name,
        required,
        cpf: (val) => validateCPF(val) || this.invalidCPFLabel,
        cnpj: (val) => validateCNPJ(val) || this.invalidCNPJLabel,
      },

      mask: {
        cpfCnpj,
      },

      loading: false,
      showQrCode: false,

      pixQRCode: '',
      pixStringCode: '',
      installmentId: '',
    }
  },
}
</script>
